import React, { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import { FiX } from 'react-icons/fi'
import colors from '../../lib/colors'
import theme from '../../lib/theme'
import { StateAction } from '../../types/typeAliases'

const Styles = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  bottom: 36px;
  left: 4px;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  color: ${colors.darkestGray};
  font-size: 13px;
  section {
    margin-bottom: 8px;
    line-height: 18px;
    word-break: break-word;
  }
  section p {
    margin: 0;
  }
  &:before {
    content: '';
    position: absolute;
    top: 20px;
    left: 0;
    width: 96%;
    height: 20px;
    background: linear-gradient(
      rgba(255, 255, 255, 255),
      rgba(255, 255, 255, 0)
    );
    pointer-events: none;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 96%;
    height: 50px;
    background: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 255)
    );
    pointer-events: none;
  }
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s;
  &.show {
    opacity: 1;
    pointer-events: all;
  }
  &.embedMode {
    transition: none;
    position: relative;
    height: 0;
    ${theme.inset0};
    border: 0;
    &:before,
    &:after {
      display: none;
    }
  }
  &.show.embedMode {
    height: auto;
    grid-column: span 2;
  }
`
const Controls = styled.div`
  height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  color: ${colors.darkestGray};
  transition: color 0.2s;
  svg {
    cursor: pointer;
    width: 20px;
    height: auto;
  }
  :hover {
    color: ${colors.black};
  }
  &.embedMode {
    display: none;
  }
`
const Container = styled.div`
  padding: 20px 5px 40px;
  /* subtract height of controls (20px) above */
  height: calc(100% - 20px);
  overflow-y: auto;
  ${theme.itemScrollbar};
  box-sizing: border-box;
  &.embedMode {
    padding: 12px;
    height: auto;
  }
`
interface IDetailsProps {
  children: ReactNode
  showPopup: boolean
  setShowPopup: StateAction<boolean>
  embedMode?: boolean
}
export default function ItemPopup(props: IDetailsProps): ReactElement | null {
  const {
    children, showPopup, setShowPopup, embedMode,
  } = props

  const classes = `${showPopup ? 'show' : ''} ${embedMode ? 'embedMode' : ''}`

  return (
    <Styles className={classes}>
      <Controls className={embedMode ? 'embedMode' : ''}>
        <FiX onClick={(): void => setShowPopup(false)} />
      </Controls>
      <Container className={embedMode ? 'embedMode' : ''}>{children}</Container>
    </Styles>
  )
}
